import { render, staticRenderFns } from "./IconSvgUsa.vue?vue&type=template&id=11ab2cbf&scoped=true&"
import script from "./IconSvgUsa.vue?vue&type=script&lang=js&"
export * from "./IconSvgUsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab2cbf",
  null
  
)

export default component.exports